import { IAccount } from './account.type';
import { IBaseEntity, IBaseQuery } from './common.type';
import { IPackage } from './package.type';

export interface IPayment extends IBaseEntity {
  value: number;
  code: string;
  note?: string;
  package_id?: string;
  method: EPaymentMethod;
  success_at?: string;
  cancel_at?: string;
  user_created: IAccount;
  package: IPackage;
}

export interface IPaymentQuery extends IBaseQuery {
  method?: EPaymentMethod;
  status?: number;
  start?: string;
  end?: string;
}

export enum EPaymentMethod {
  TRANSFER = 'TRANSFER',
  COD = 'COD',
}

export interface IPaymentDashboard {
  count: number;
  total_price: number;
  count_user: number;
  total_success_price: number;
  total_cancel_price: number;
  total_waitting_price: number;
  count_success: number;
  count_cancel: number;
  count_waitting: number;
}
